import { createFormReducer } from '@td/utils';
import { PROVIDER_SURGE_INCENTIVE_SEARCH_FORM } from '../action-types';

export default createFormReducer({
  fields:          ['state', 'active-only', 'starting-after'],
  formActionTypes: PROVIDER_SURGE_INCENTIVE_SEARCH_FORM
});
